<div data-testid="eAuth-container" class="eauth">
    <div class="tooltip">
        <div id="eauth-info-label">eAuthorization
            <div class="tooltiptext">
                <div id="inEligible-account" data-testid="inEligibleAccount" *ngIf="!isEauthEligibleAccount">{{
                    eAuthTooltipText }}</div>
                <div id="eligible-accountholders" data-testid="eligibleAccountHolders"
                    *ngIf="isEauthEligibleAccount && eligibleCustomers.length > 0">{{ eAuthTooltipText }}
                    <ul>
                        <li *ngFor="let customer of eligibleCustomers">
                            {{customer?.emailId}}
                        </li>
                    </ul>
                </div>
                <div *ngIf="isEauthEligibleAccount && pendingCustomers.length > 0" id="pending-account-holders"
                    data-testid="pendingAccountHolders">{{ pendingSetupText }}
                    <ul>
                        <li *ngFor="let customer of pendingCustomers">
                            {{customer?.emailId}}
                        </li>
                    </ul>
                </div>
                <div *ngIf="requiresEAuthSetup" id="requires-eAuth-setup" data-testid="requiresEAuthSetup">
                    {{eAuthTooltipText}}</div>
                <div *ngIf="missingEmailAddress" id="missing-email-address" data-testid="missingEmailAddress">
                    {{missingEmailText}}</div>

                <a data-testid="addEditLink" *ngIf="displayAddHyperLink" (click)="routeReturned()"
                    routerLinkActive="nav-active">{{
                    eAuthAddLink }}</a>
            </div>
        </div>
    </div>
    <div id="eauth-status-section">
        <div id="inEligible-label" class="eauthNotAuthorized" data-testid="inEligibleLabel" *ngIf="!isEauthEligibleAccount">
            Ineligible
        </div>

        <div id="eligible-accountholders-label" data-testid="eligibleAccountHoldersLabel" *ngIf="isEauthEligibleAccount && eligibleCustomers.length > 0">
            <div id="success-icon" data-testid="success-icon" class="success-icon"></div>
                <div class="eauthAuthorized">Ready</div>
        </div>

        <div class="eauthSetup">
            <a id="requires-eAuth-setup-label" data-testid="requires-eAuth-setup" *ngIf="requiresEAuthSetup"  (click)="routeReturned()" routerLinkActive="nav-active">
              Set up eAuth
            </a>
        </div>

        <div data-testid="pendingAccountHoldersLabel" *ngIf="isEauthEligibleAccount && pendingCustomers.length > 0 && !someAccountHoldersEligible">
            <div class="eauthStatus">Pending</div>
        </div>
  </div>
</div>
